import { render, staticRenderFns } from "./_addNote.vue?vue&type=template&id=5e66898b&"
import script from "./_addNote.vue?vue&type=script&lang=js&"
export * from "./_addNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports